import { render } from "./ProfileDetails.vue?vue&type=template&id=e788865c"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Studio Sport\\ECM_HYBRID_STUDIO_SPORT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__